<template>
	<div class="card border-0 card-with-shadow">
		<div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">

			<h5 v-show="isDetailsActive" class="card-title text-muted mb-0">{{ $t('warehouse_info') }}</h5>
			<h5 v-show="!isDetailsActive" class="card-title text-muted mb-0">{{ $t('warehouse_info_edit') }}</h5>

			<div>
				<a v-show="!isDetailsActive" class="text-muted" href="#" @click.prevent="detailsInfoClose">
					<app-icon name="x-square" stroke-width="1"/>
				</a>
				<a v-show="!isDetailsActive" class="text-muted" href="#" @click.prevent="detailsInfoSync">
					<app-icon name="check-square" stroke-width="1"/>
				</a>
				<a v-show="isDetailsActive" class="text-muted" href="#" @click.prevent="detailsInfoEdit">
					<app-icon name="edit" stroke-width="1"/>
				</a>
			</div>

		</div>
		<div class="card-body">

			<div v-show="isDetailsActive">
                <div class="row d-flex align-items-center">
                    <div class="col-12 col-lg-3 border-right">
                        <app-warehouse-info-details :user-info-sync-url="`crm/warehouses/profile-picture/${detailsData.id}`"
                                :user-info-data="detailsData" component-type="warehouse"  />
                    </div>
                    <div class="col-12 col-lg-3 border-right">
                        <div class="form-group mb-3">
                            <div class="form-row">
                                <label class="mb-0 text-muted col-5 d-flex align-items-center">
                                    {{ $t('warehouse_name') }}:
                                </label>
                                <div class="col-7">
                                    {{detailsData.name}}
                                </div>
                            </div>
                        </div>
                        <div class="form-group mb-3">
                            <div class="form-row">
                                <label class="mb-0 text-muted col-5 d-flex align-items-center">
                                    {{ $t('warehouse_type') }}:
                                </label>
                                <div class="col-7">
                                    <span class="badge badge badge-primary badge-pill">{{detailsData.warehouse_type.name}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group mb-3">
                            <div class="form-row">
                                <label class="mb-0 text-muted col-5 d-flex align-items-center">
                                    {{ $t('warehouse_price') }}:
                                </label>
                                <div class="col-7">
                                    {{ numberWithCurrencyMuseum(detailsData.price) }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-3 border-right">
                        <div class="form-group mb-3">
                            <div class="form-row">
                                <label class="mb-0 text-muted col-5 d-flex align-items-center">
                                    {{ $t('warehouse_pre') }}:
                                </label>
                                <div class="col-7">
                                    {{detailsData.pre.qty}} {{$t('qty')}} ({{ numberWithCurrencyMuseum(detailsData.pre.price) }})
                                </div>
                            </div>
                        </div>
                        <div class="form-group mb-3">
                            <div class="form-row">
                                <label class="mb-0 text-muted col-5 d-flex align-items-center">
                                    {{ $t('warehouse_rase') }}:
                                </label>
                                <div class="col-7">
                                    {{detailsData.rase.qty}} {{$t('qty')}}
                                </div>
                            </div>
                        </div>
                        <div class="form-group mb-3">
                            <div class="form-row">
                                <label class="mb-0 text-muted col-5 d-flex align-items-center">
                                    {{ $t('warehouse_ord') }}:
                                </label>
                                <div class="col-7">
                                    {{detailsData.ord.qty}} {{$t('qty')}} ({{ numberWithCurrencyMuseum(detailsData.ord.price) }})
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-3">
                        <div class="form-group mb-3">
                            <div class="form-row">
                                <label class="mb-0 text-muted col-5 d-flex align-items-center">
                                    <h3>{{ $t('warehouse_sum') }}:</h3>
                                </label>
                                <div class="col-7">
                                   <h3> {{detailsData.sum}} {{$t('qty')}} </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
							
			</div>

			<div v-show="!isDetailsActive">
                <div class="row d-flex align-items-center">
                    <div class="col-12 col-lg-4">
                        <div class="form-group mb-3">
                            <div class="form-row">
                                <label class="mb-0 text-muted col-5 d-flex align-items-center">
                                    {{ $t('warehouse_name') }}:
                                </label>
                                <div class="col-7">
                                    <app-input v-model="detailsData.name"
							           :error-message="$errorMessage(errors, 'name')"
										   :placeholder="$t('enter_name')"
							           type="text"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div class="form-group mb-3">
                            <div class="form-row">
                                <label class="mb-0 text-muted col-5 d-flex align-items-center">
                                    {{ $t('warehouse_type') }}:
                                </label>
                                <div class="col-7">
                                    <app-input type="select" list-value-field="name" :list="warehouseTypeList" :placeholder="$t('choose_a_country')"
                                        v-model="detailsData.warehouse_type_id" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div class="form-group mb-3">
                            <div class="form-row">
                                <label class="mb-0 text-muted col-5 d-flex align-items-center">
                                    {{ $t('warehouse_price') }}:
                                </label>
                                <div class="col-7">
                                    <app-input v-model="detailsData.price"
							           :error-message="$errorMessage(errors, 'price')"
										   :placeholder="$t('enter_price')"
							           type="number"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
			</div>

		</div>
	</div>
</template>

<script>

import {FormMixin} from "@core/mixins/form/FormMixin.js";
import {formatDateToLocal, urlGenerator, numberWithCurrencyMuseum} from "@app/Helpers/helpers";

export default {
	name: "DetailsInformationFund",
	mixins: [FormMixin],
	props: {
		detailsData: {
			type: Object,
			required: true
		},
		detailsSyncUrl: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			urlGenerator,
			formatDateToLocal,
			numberWithCurrencyMuseum,
			isDetailsActive: true,
			formData: {},
			
			countryList: [],
			OwList: [
	  		 	{ id: "1", name: "Собственник",},
				{ id: "2", name: "Аренда",},

	  		],
			errors: {}
		}
	},
	computed: {
        warehouseTypeList() {
            return this.$store.getters.WarehouseType
        },
		
		
		
		
		
	
	
	},
	methods: {
		detailsInfoSync() {
            this.formData.name = this.detailsData.name;
            this.formData.price = this.detailsData.price;
            this.formData.warehouse_type_id = this.detailsData.warehouse_type_id;

			this.formData.owner_id = this.detailsData.owner_id;
			this.submitFromFixin('patch', this.detailsSyncUrl, this.formData);
		},

		afterError(response) {
			this.errors = response.data.errors
		},

		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.isDetailsActive = true
			this.errors = {}
			this.$emit('update-request');
		},

		detailsInfoClose() {
			this.isDetailsActive = true;
		},
		detailsInfoEdit() {
			this.isDetailsActive = false
		},
		
		
	},
	created() {
		
		this.$store.dispatch('WarehouseType');
		
		
		
	},
}
</script>

